<template>
  <div v-if="warranty">
    <!-- SỬA CHỮA: nhiều phiên -->
    <div
      v-for="(session, index) in warrantyRepairs"
      :key="repairSessionKey(session, index)"
      class="repair-wrap mb-3"
    >
      <div class="repair-wrap__header">
        <span class="repair-wrap__title">SỬA CHỮA KỸ THUẬT</span>
        <div class="repair-wrap__header-meta d-flex align-items-center flex-wrap">
          <div class="d-flex align-items-center repair-session-heading-wrap">
            <div
              class="repair-session-badge"
              aria-hidden="true"
            >
              {{ index + 1 }}
            </div>
            <div class="repair-session-heading">
              <div class="repair-session-heading__name">
                {{ session.primaryTechnicianName }}
              </div>
              <div
                v-if="session.startAt"
                class="repair-session-heading__time"
                v-b-tooltip.hover
                :title="'Thời gian bắt đầu sửa chữa'"
              >
                {{ session.startAt }}
              </div>
            </div>
          </div>
          <b-button
            v-if="warrantyRepairs.length > 1"
            size="sm"
            variant="danger"
            class="font-weight-bolder mr-4"
            @click="onConfirmDeleteSession(index)"
          >
            <i class="fas fa-trash-alt mr-1"></i>
            Xóa phiên
          </b-button>
        </div>
      </div>

      <div class="repair-wrap__body">
        <b-row class="m-0">
          <!-- Left -->
          <b-col
            cols="12"
            md="6"
            class="p-3"
          >
            <div class="border rounded p-3">
              <h6 class="font-weight-bold mb-3">THÔNG TIN SỬA CHỮA</h6>

              <div>
                <b-row>
                  <b-col cols="6">
                    <b-form-group>
                      <label class="font-weight-bold">Mức độ</label>
                      <b-form-select
                        size="sm"
                        class="select-style"
                        :value="session.errorSeverityId"
                        :options="severityLevelOptions"
                        value-field="value"
                        text-field="text"
                        @input="updateSessionField(index, 'errorSeverityId', $event)"
                      >
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <label class="font-weight-bold">Nhóm lỗi</label>
                      <b-form-select
                        size="sm"
                        class="select-style"
                        :value="session.errorGroupId"
                        :options="errorGroupOptions"
                        value-field="value"
                        text-field="text"
                        @input="onErrorGroupChangeForSession(index, $event)"
                      >
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <label class="font-weight-bold">Lỗi kỹ thuật</label>
                      <div class="technical-errors-ms position-relative">
                        <vue-multi-select
                          :value="session.technicalErrors || []"
                          :options="technicalErrorOptionsFor(index)"
                          placeholder="Chọn lỗi kỹ thuật"
                          option-label="name"
                          @input="onTechnicalErrorsInput(index, $event)"
                        ></vue-multi-select>
                        <div
                          v-if="!session.errorGroupId"
                          class="technical-errors-ms__shield"
                          title="Chọn nhóm lỗi trước"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <b-row>
                <b-col cols="4">
                  <b-form-group>
                    <label class="font-weight-bold">Kỹ thuật viên</label>
                    <EmployeeSearch
                      :value="session.primaryTechnicianName"
                      :employee-id="session.primaryTechnicianId"
                      placeholder="Tên hoặc mã nhân viên"
                      @employee-selected="
                        (emp) => onPrimaryTechnicianSelectedForSession(index, emp)
                      "
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group>
                    <label class="font-weight-bold">Thời hạn sửa</label>
                    <date-picker
                      placeholder="Chọn ngày giờ"
                      class="form-control form-control-sm"
                      :config="dpConfigs.datetime"
                      :value="session.estimatedCompletionAt"
                      @input="updateSessionField(index, 'estimatedCompletionAt', $event)"
                    ></date-picker>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group>
                    <label class="font-weight-bold">Thời hạn trả</label>
                    <date-picker
                      placeholder="Chọn ngày giờ"
                      class="form-control form-control-sm"
                      :config="dpConfigs.datetime"
                      :value="session.actualCompletionAt"
                      @input="updateSessionField(index, 'actualCompletionAt', $event)"
                    ></date-picker>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>

          <!-- Right -->
          <b-col
            cols="12"
            md="6"
            class="p-3"
          >
            <div class="border rounded p-3">
              <h6 class="font-weight-bold mb-3">KẾT LUẬN</h6>
              <b-row class="align-items-end">
                <b-col cols="6">
                  <b-form-group class="mb-0">
                    <label class="font-weight-bold d-flex align-items-center mb-2">
                      Giải pháp
                    </label>
                    <b-form-select
                      size="sm"
                      class="select-style"
                      :value="session.solutionId"
                      :options="solutionOptions"
                      value-field="id"
                      text-field="name"
                      @input="updateSessionField(index, 'solutionId', $event)"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null"
                          >--Chọn giải pháp--</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="6"
                  v-if="isReplaceSolutionForSession(session)"
                >
                  <b-button
                    size="sm"
                    variant="primary"
                    class="font-weight-bolder"
                    :disabled="disableReplaceExportButton"
                    @click="exportReplaceProducts(index)"
                  >
                    <i class="fas fa-external-link-alt mr-1"></i>
                    Xuất linh kiện
                  </b-button>
                </b-col>
              </b-row>

              <template>
                <div
                  class="d-flex align-items-center justify-content-between replace-products-wrap"
                >
                  <div class="d-flex align-items-center">
                    <span class="font-weight-bold mr-2">Linh kiện đã xuất kho</span>
                    <b-badge
                      v-if="replaceProductsCountForSession(session) > 0"
                      variant="success"
                      @click="toggleReplaceProductsExpanded(session, index)"
                      class="cursor-pointer"
                    >
                      {{ replaceProductsCountForSession(session) }}
                    </b-badge>
                    <b-badge
                      v-else
                      variant="primary"
                      >0</b-badge
                    >
                  </div>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    v-if="replaceProductsCountForSession(session)"
                    @click="toggleReplaceProductsExpanded(session, index)"
                  >
                    <i
                      class="fas"
                      :class="
                        isReplaceProductsExpanded(session, index)
                          ? 'fa-chevron-up'
                          : 'fa-chevron-down'
                      "
                    ></i>
                    <span class="ml-1">{{
                      isReplaceProductsExpanded(session, index) ? 'Thu gọn' : 'Mở rộng'
                    }}</span>
                  </b-button>
                </div>

                <div
                  v-show="
                    isReplaceProductsExpanded(session, index) &&
                    replaceProductsCountForSession(session) > 0
                  "
                >
                  <ReplaceProductsTable
                    :items="replaceProductsForSession(session)"
                    :show-when-empty="true"
                  />
                </div>
              </template>

              <b-row class="mt-13">
                <b-col cols="9">
                  <b-form-group>
                    <label class="font-weight-bold d-flex align-items-center mb-2">
                      Cách sửa
                    </label>
                    <b-form-textarea
                      size="sm"
                      :value="session.repairSolution"
                      @input="updateSessionField(index, 'repairSolution', $event)"
                      placeholder="Nhập cách sửa"
                      rows="1"
                      class="repair-solution-textarea"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group>
                    <label class="font-weight-bold">Số tiền sửa</label>
                    <BInputNumber
                      :value="session.repairCost"
                      @valueChange="updateSessionField(index, 'repairCost', $event)"
                      placeholder="Nhập tiền sửa"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="align-items-center justify-content-between">
                <b-col cols="8">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      :checked="session.isCannotRepair"
                      @change="updateSessionField(index, 'isCannotRepair', $event)"
                      class="mr-3"
                    >
                      Không sửa được
                    </b-form-checkbox>

                    <b-form-checkbox
                      :checked="session.isDisagreePrice"
                      @change="updateSessionField(index, 'isDisagreePrice', $event)"
                    >
                      Không đồng ý giá
                    </b-form-checkbox>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- Linh kiện xuất không gắn với kỹ thuật viên nào -->
    <div
      v-if="orphanedReplaceProducts.length > 0"
      class="repair-wrap orphaned-wrap mb-3"
    >
      <div class="repair-wrap__header orphaned-wrap__header">
        <span class="repair-wrap__title">LINH KIỆN XUẤT KHÁC</span>
        <div class="repair-wrap__header-meta d-flex align-items-center">
          <b-badge
            variant="warning"
            class="mr-2 cursor-pointer"
            @click="orphanedReplaceProductsExpanded = !orphanedReplaceProductsExpanded"
          >
            {{ orphanedReplaceProducts.length }}
          </b-badge>
          <small class="text-muted mr-3">Linh kiện xuất không theo kỹ thuật viên</small>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="orphanedReplaceProductsExpanded = !orphanedReplaceProductsExpanded"
          >
            <i
              class="fas"
              :class="orphanedReplaceProductsExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
            <span class="ml-1">{{ orphanedReplaceProductsExpanded ? 'Thu gọn' : 'Mở rộng' }}</span>
          </b-button>
        </div>
      </div>
      <div
        v-show="orphanedReplaceProductsExpanded"
        class="p-3"
      >
        <ReplaceProductsTable
          :items="orphanedReplaceProducts"
          :show-when-empty="true"
        />
      </div>
    </div>

    <b-row>
      <b-col cols="12">
        <button
          v-if="!disableReplaceExportButton"
          type="button"
          class="add-repair-session-btn mb-3 w-100"
          @click="addRepairSession"
        >
          <i class="fas fa-plus mr-2"></i>
          Thêm phiên sửa chữa mới
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue'
import timeUtils from '@/utils/date'
import { cloneDeep, makeToastFaile } from '@/utils/common'
import { getTechnicalErrorsByGroup } from '../utils/warrantyApi'
import { showDeleteAlert } from '@/utils/sweet-alert2'
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue'
import ReplaceProductsTable from './ReplaceProductsTable.vue'
import VueMultiSelect from 'vue-simple-multi-select'

export default {
  name: 'WarrantyRepairSection',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    warrantyRepairs: {
      type: Array,
      default: () => [{}],
    },
    disableReplaceExportButton: {
      type: Boolean,
      default: false,
    },
    solutionOptions: {
      type: Array,
      default: () => [],
    },
    severityLevelOptions: {
      type: Array,
      default: () => [],
    },
    errorGroupOptions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    EmployeeSearch,
    BInputNumber,
    ReplaceProductsTable,
    VueMultiSelect,
  },
  data() {
    return {
      dpConfigs: {
        datetime: { ...timeUtils.DP_CONFIG_DATETIME.date, widgetPositioning: { vertical: 'top' } },
      },
      replaceProductsExpandedByKey: {},
      technicalErrorOptionsBySession: {},
      lastErrorGroupBySession: {},
      orphanedReplaceProductsExpanded: false,
    }
  },
  watch: {
    warrantyRepairs: {
      handler(newVal, oldVal) {
        if (newVal?.length !== oldVal?.length) {
          this.technicalErrorOptionsBySession = {}
          this.lastErrorGroupBySession = {}
          this.replaceProductsExpandedByKey = {}
        }
        this.$nextTick(() => this.bootstrapTechnicalErrorsForSessions())
      },
      immediate: true,
    },
  },
  computed: {
    warranty() {
      return this.value
    },
    orphanedReplaceProducts() {
      const all = Array.isArray(this.warranty?.replaceProducts) ? this.warranty.replaceProducts : []
      const technicianIds = new Set(
        (this.warrantyRepairs || [])
          .map((s) => s.primaryTechnicianId)
          .filter((id) => id != null && id !== '')
          .map((id) => Number(id)),
      )
      return all.filter((p) => !technicianIds.has(Number(p.createdBy)))
    },
  },
  methods: {
    allReplaceProducts() {
      const list = this.warranty?.replaceProducts
      return Array.isArray(list) ? list : []
    },
    replaceProductsForSession(session) {
      const primaryTechnicianId = session?.primaryTechnicianId
      if (primaryTechnicianId == null || primaryTechnicianId === '') return []
      return this.allReplaceProducts().filter(
        (p) => Number(p.createdBy) === Number(primaryTechnicianId),
      )
    },
    replaceProductsCountForSession(session) {
      return this.replaceProductsForSession(session).length
    },
    isReplaceProductsExpanded(session, index) {
      const key = this.repairSessionKey(session, index)
      return !!this.replaceProductsExpandedByKey[key]
    },
    toggleReplaceProductsExpanded(session, index) {
      const key = this.repairSessionKey(session, index)
      const next = !this.replaceProductsExpandedByKey[key]
      this.$set(this.replaceProductsExpandedByKey, key, next)
    },
    repairSessionKey(session, index) {
      return session.id ? `r-${session.id}` : `new-${index}`
    },
    isReplaceSolutionForSession(session) {
      const solutionId = session?.solutionId
      if (solutionId == null || solutionId === '') return false
      const foundSolution = this.solutionOptions.find((s) => s.id === solutionId)
      return foundSolution?.code === 'REPLACE'
    },
    emitRepairs(next) {
      this.$emit('update:warrantyRepairs', next)
    },
    updateSessionField(index, field, value) {
      if (this.warrantyRepairs[index]?.[field] === value) return
      const next = cloneDeep(this.warrantyRepairs)
      if (!next[index]) next[index] = {}
      next[index][field] = value
      this.emitRepairs(next)
    },
    onTechnicalErrorsInput(index, value) {
      if (!this.warrantyRepairs[index]?.errorGroupId) return
      this.updateSessionField(index, 'technicalErrors', value)
    },
    addRepairSession() {
      this.emitRepairs([
        ...cloneDeep(this.warrantyRepairs),
        {
          startAt: timeUtils.getCurrentDate(timeUtils.CLIENT_DATE_TIME_NO_SECONDS),
          errorGroupId: null,
          technicalErrors: [],
          errorSeverityId: null,
          solutionId: null,
        },
      ])
    },
    removeRepairSession(index) {
      const next = cloneDeep(this.warrantyRepairs)
      next.splice(index, 1)
      this.technicalErrorOptionsBySession = {}
      this.lastErrorGroupBySession = {}
      this.emitRepairs(next.length ? next : [{}])
      this.$nextTick(() => this.bootstrapTechnicalErrorsForSessions())
    },
    onConfirmDeleteSession(index) {
      showDeleteAlert(
        'Xoá phiên sửa chữa?',
        'Phiên sửa chữa sẽ bị xoá sau khi lưu.',
        index,
        (idx) => this.removeRepairSession(idx),
      )
    },
    technicalErrorOptionsFor(index) {
      return this.technicalErrorOptionsBySession[index] || []
    },
    onPrimaryTechnicianSelectedForSession(index, employee) {
      const next = cloneDeep(this.warrantyRepairs)
      if (!next[index]) next[index] = {}
      next[index].primaryTechnicianId = employee ? employee.id : null
      next[index].primaryTechnicianName = employee ? employee.name : ''
      this.emitRepairs(next)
    },
    bootstrapTechnicalErrorsForSessions() {
      ;(this.warrantyRepairs || []).forEach((s, idx) => {
        if (s.errorGroupId) {
          this.fetchTechnicalErrorsForSession(idx, s.errorGroupId)
        } else {
          this.$set(this.technicalErrorOptionsBySession, idx, [])
        }
      })
    },
    async fetchTechnicalErrorsForSession(sessionIndex, errorGroupId) {
      if (!errorGroupId) return
      if (
        this.lastErrorGroupBySession[sessionIndex] === errorGroupId &&
        (this.technicalErrorOptionsBySession[sessionIndex] || []).length
      ) {
        return
      }
      this.lastErrorGroupBySession[sessionIndex] = errorGroupId
      const options = await getTechnicalErrorsByGroup(errorGroupId)
      this.$set(this.technicalErrorOptionsBySession, sessionIndex, options)

      const session = this.warrantyRepairs[sessionIndex]
      if (session?.technicalErrors?.length) {
        const ids = session.technicalErrors.map((e) => String(e.id))
        const matched = options.filter((opt) => ids.includes(String(opt.id)))
        if (matched.length) {
          const next = cloneDeep(this.warrantyRepairs)
          if (!next[sessionIndex]) next[sessionIndex] = {}
          next[sessionIndex].technicalErrors = matched
          this.emitRepairs(next)
        }
      }
    },
    onErrorGroupChangeForSession(index, errorGroupId) {
      const cur = this.warrantyRepairs[index]
      if (cur && cur.errorGroupId !== errorGroupId) {
        this.updateSessionField(index, 'technicalErrorIds', null)
        this.updateSessionField(index, 'technicalErrors', [])
      }
      this.updateSessionField(index, 'errorGroupId', errorGroupId)
      if (errorGroupId) {
        this.lastErrorGroupBySession[index] = null
        this.fetchTechnicalErrorsForSession(index, errorGroupId)
      } else {
        this.$set(this.technicalErrorOptionsBySession, index, [])
        this.lastErrorGroupBySession[index] = null
      }
    },
    exportReplaceProducts(index) {
      if (this.disableReplaceExportButton) return
      const warrantyRepair = this.warrantyRepairs[index]
      if (!warrantyRepair.primaryTechnicianId) {
        makeToastFaile(
          `Vui lòng chọn kỹ thuật viên cho phiên sửa chữa ${index + 1} trước khi xuất linh kiện`,
        )
        return
      }
      const route = this.$router.resolve({
        name: 'add-inventory-dispatch',
        query: {
          storeId: this.warranty.storeId,
          warrantyId: this.warranty.id,
          fromWarranty: true,
          providerId: this.warranty.customerId,
          createdBy: warrantyRepair.primaryTechnicianId,
          createdByName: warrantyRepair.primaryTechnicianName,
        },
      })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.repair-wrap {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: visible;
}
.repair-wrap__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #dee2e6;
}
.repair-wrap__header-meta {
  gap: 12px;
  margin-left: auto;
}
.repair-session-heading-wrap {
  gap: 10px;
}
.repair-session-badge {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: #0d6efd;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.repair-session-heading {
  min-width: 0;
}
.repair-session-heading__name {
  font-weight: 700;
  color: #343a40;
  font-size: 15px;
  line-height: 1.25;
  min-width: 100px;
}
.repair-session-heading__time {
  font-size: 10px;
  color: #6c757d;
  margin-top: 2px;
  line-height: 1.25;
}
.repair-wrap__title {
  font-weight: 700;
  letter-spacing: 0.02em;
}
.repair-solution-textarea {
  min-height: calc(1.5em + 0.5rem + 2px);
  height: calc(1.5em + 0.5rem + 10px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.add-repair-session-btn {
  border: 2px dashed #6c9fd9;
  border-radius: 8px;
  background: transparent;
  color: #337ab7;
  font-weight: 600;
  padding: 12px 16px;
  transition: background 0.15s ease;
}
.add-repair-session-btn:hover {
  background: rgba(51, 122, 183, 0.08);
}
.replace-products-wrap {
  margin-top: 2.25rem !important;
}
.orphaned-wrap__header {
  background-color: #fff8e1;
  border-bottom: 1px solid #ffe082;
}
.technical-errors-ms__shield {
  position: absolute;
  inset: 0;
  z-index: 2;
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 0.25rem;
}
</style>

